module.exports = __webpack_public_path__ + "static/media/pipe_1.23b8676b.png";